module.exports = __webpack_public_path__ + "static/feature3-4e0664ae89aab0fc63d18645ecce24b9.png";